export default "__VITE_ASSET__B5YmHVPX__"